module.exports = __webpack_public_path__ + "img/Clients.8872dbf2.svg";